/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useState} from 'react';
import {useEffect} from 'react';
import {View, Platform, ScrollView} from 'react-native';
import {connect} from 'react-redux';
import { HeaderScreen } from '../../../components/Header/HeaderScreen';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import { GlossaireComponent } from '../../../components/Glossaire';

export function DetailNotificationScreen(props: any) {
  const {
    route,
    notificationVuUser,
    notificationUser,
    user,
    notificationNotSeenUser,
    initialNotificationUser,
  } = props;
  const {id, data, libelle} = route.params;
  const [titleHeader, setTitleHeader] = useState(data);
  const idUser =
    user && user.data && user.data.utilisateur && user.data.utilisateur.id;

  const videNotification = () => {
    initialNotificationUser({}, () => {});
  };

  const getNotificationUser = (
    idUser: string,
    page: number,
    rowPerPage: number,
  ) => {
    notificationUser(
      {},
      () => {},
      `${idUser}?page=${page}&rowPerPage=${rowPerPage}`,
    );
  };

  const initialisationNotification = async (idUser: string) => {
    videNotification();
  };

  useEffect(() => {
    notificationNotSeenUser({}, () => {}, `${id}`);
    notificationVuUser({}, () => {}, `${id}`);
    initialisationNotification(idUser);
    Platform.OS === 'web'
      ? setTitleHeader('Notification > ' + data)
      : setTitleHeader(data);
  }, []);
  
  return (
    <View style={{flex: 1}}>
      <HeaderScreen title={titleHeader} type="retour" noBreadcrumb={false} />
      <ScrollView style={{backgroundColor: '#fff', flex: 1}}>
        <GlossaireComponent
          title="Notification"
          word={data}
          definition={libelle}
        />
      </ScrollView>
    </View>
  );
}

export const DetailNotification: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetailNotificationScreen);
